"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* The Sent tab's filters and groupings, applied on the client to the rows
 * ListSentForms returns (newest first). */
var _forms = require('shared/services/forms');
























 const forTeam = (rows, teamKey) =>
  teamKey ? rows.filter(row => _optionalChain([row, 'access', _ => _.TeamKeys, 'optionalAccess', _2 => _2.includes, 'call', _3 => _3(teamKey)])) : [...rows]; exports.forTeam = forTeam

 const sentCounts = (rows) => ({
  open: rows.filter(row => _forms.isOpenStatus.call(void 0, row.Status)).length,
  all: rows.length,
}); exports.sentCounts = sentCounts

const shown = (rows, filter) =>
  filter === 'open' ? rows.filter(row => _forms.isOpenStatus.call(void 0, row.Status)) : [...rows]

/* One group per family (its patient), in order of its newest send. Groups
 * with nothing left to show under the filter drop out. */
 const byFamily = (rows, filter) => {
  const groups = new Map()
  rows.forEach(row => {
    const key = row.PatientKey || row.ChatKey
    const group = _nullishCoalesce(groups.get(key), () => ( {
      key, name: row.PatientName, team: _optionalChain([row, 'access', _4 => _4.TeamNames, 'optionalAccess', _5 => _5[0]]) || '', chatKey: row.ChatKey, owes: 0, rows: [],
    }))
    if (_forms.isOpenStatus.call(void 0, row.Status)) group.owes++
    group.rows.push(row)
    groups.set(key, group)
  })
  return [...groups.values()]
    .map(group => ({ ...group, rows: shown(group.rows, filter) }))
    .filter(group => group.rows.length > 0)
}; exports.byFamily = byFamily

/* One group per form, in order of its newest send. */
 const byForm = (rows, filter) => {
  const groups = new Map()
  rows.forEach(row => {
    const group = _nullishCoalesce(groups.get(row.FormKey), () => ( {
      key: row.FormKey,
      name: row.FormName,
      firstPageURL: _optionalChain([row, 'access', _6 => _6.FirstPage, 'optionalAccess', _7 => _7.URL]) || '',
      sent: 0,
      familiesOwing: 0,
      rows: [],
      owing: new Set(),
    }))
    group.sent++
    if (_forms.isOpenStatus.call(void 0, row.Status)) group.owing.add(row.PatientKey || row.ChatKey)
    group.rows.push(row)
    groups.set(row.FormKey, group)
  })
  return [...groups.values()]
    .map(({ owing, ...group }) => ({ ...group, familiesOwing: owing.size, rows: shown(group.rows, filter) }))
    .filter(group => group.rows.length > 0)
}; exports.byForm = byForm

 const flat = (rows, filter) => shown(rows, filter); exports.flat = flat
